import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./SelectUserAndWorkers.css";
import TextInput from "../UIkit/TextInput";
import SearchIcon from "@mui/icons-material/Search";
import DropdownList from "./DoropdownList";
import { toKanaString } from "../../functions/common";
import classModule from "./SelectWorker.module.scss";
import DropdownListForOrderEmail from "./DoropdownListForOrderEmail";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { AUTHORIZED_ORDER_USER_ROLES } from "../../functions/isAuth";

const useStyles = makeStyles((theme) => ({
  userSearch: {
    display: "flex",
    alignItems: "center",
  },
  searchButton: {
    marginTop: "20px",
    width: "24px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#757575",
  },
}));

const SelectOrderEmail = (props) => {
  const classes = useStyles();
  const { setShowSelectEmail, email, setEmail } = props;
  const [userList, setUserList] = useState([]);
  const [prevUser, setPrevUser] = useState({
    email: email,
  });
  //決定ボタンが押されたとき
  const handleDecideButtonClick = () => {
    setShowSelectEmail(false);
  };
  //キャンセルボタンが押されたとき
  const handleCancelButtonClick = () => {
    setEmail(prevUser.email);
    setShowSelectEmail(false);
  };
  useEffect(() => {
    const usersRef = collection(db, "users");
    const q = query(
      usersRef,
      where("role", "in", AUTHORIZED_ORDER_USER_ROLES)
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      let updatedUsers = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      updatedUsers = updatedUsers.sort((a, b) => {
        return Number(a.usernumber) - Number(b.usernumber);
      });
      const updatedList = updatedUsers
        .map((user) => {
          return [
            user.usernumber,
            user.username,
            user.departmentid,
            user.departmentname,
            user.email,
          ];
        })
        .filter((user) => user[0]);
      console.log(updatedUsers);
      setUserList(updatedList);
    });

    // コンポーネントのアンマウント時にリスナーを解除
    return () => unsubscribe();
  }, []);

  return (
    <aside className={classModule.modalContainer}>
      <div className={classModule.modal}>
        <h2 className="u-text__headline u-text-center">発注担当者選択</h2>

        <DropdownListForOrderEmail userList={userList} setEmail={setEmail} />

        <div className={classModule.buttons}>
          <button
            className={classModule.okButton}
            onClick={handleDecideButtonClick}
          >
            決定
          </button>
          <button
            className={classModule.ngButton}
            onClick={handleCancelButtonClick}
          >
            キャンセル
          </button>
        </div>
      </div>
    </aside>
  );
};

export default SelectOrderEmail;
